import * as ng from 'angular';
import * as moment from 'moment';

const ThisYear = new Date().getFullYear();
const ServerDateFormat = 'YYYY-MM-DDTHH:mm:ss';

const mdyCountries = ['US', 'KE', 'GH'];
const ymdCountries = ['CN', 'JP', 'KR', 'CA', 'KP', 'TW', 'HU', 'MN', 'LT', 'BT'];

class DobInputController implements ng.IComponentController {
   ngFormCtrl:ng.IFormController;
   ngModelCtrl:ng.INgModelController;

   isRequired:boolean;
   minAge?:number;
   country:string;

   _day:string;
   _month:string;
   _year:string;

   orderedFields:string[];

   $onInit() {
      this.ngModelCtrl.$validators.minAge =
         (viewValue, modelValue) => this.validateAge(viewValue);

      this.ngModelCtrl.$validators.date =
         (viewValue, modelValue) => this.validateDate(viewValue);

      this.ngModelCtrl.$formatters.push(
         (modelValue:string) => this.setInputs(modelValue));
   }

   $onChanges() {
      if (!this.country) {
         this.country = 'US';
      }

      if (mdyCountries.indexOf(this.country) != -1) {
         this.orderedFields = ['M', 'D', 'Y'];
      } else if (ymdCountries.indexOf(this.country) != -1) {
         this.orderedFields = ['Y', 'M', 'D'];
      } else {
         this.orderedFields = ['D', 'M', 'Y'];
      }
   }

   onKeydown(event:KeyboardEvent) {
      // forcing numeric inputs, only works on desktop
      if (!isInputAllowed(event)) {
         event.preventDefault();
      }
   }

   private validateAge(value:string):boolean {
      if (!this.minAge) {
         return true;
      }

      // some places alchohol is illegal, we use zero age for that
      if (this.minAge === 0) {
         return false;
      }

      return !ng.isDefined(this.age) || this.age >= this.minAge;
   }

   private validateDate(value:string):boolean {
      if (this.year && this.month && this.day) {
         let year = parseInt(this.year);
         if (year < ThisYear-120) {
            return false;
         }

         return this.date.isValid();
      }

      return true;
   }

   get day() {
      return this._day;
   }

   set day(val:string) {
      this._day = val;
      this.updateViewValue();
   }

   get month() {
      return this._month;
   }

   set month(val:string) {
      this._month = val;
      this.updateViewValue();
   }

   get year() {
      return this._year;
   }

   set year(val:string) {
      this._year = val;
      this.updateViewValue();
   }

   get date() {
      let year = parseInt(this.year);
      let month = parseInt(this.month) - 1;
      let day = parseInt(this.day);

      return moment({y: year, M: month, d: day});
   }

   get age() {
      let date = this.date;
      if (date.isValid()) {
         return moment().diff(date, 'years');
      }
   }

   private updateViewValue() {
      if (this.date.isValid()) {
         this.ngModelCtrl.$setViewValue(this.date.format(ServerDateFormat));
      } else {
         // momentjs format() returns 'Invalid date' if date is invalid
         // subsequent calls to $setViewValue() will not trigger validators
         // since identity of the value did not change ('Invalid date' == 'Invalid date')
         let val = [this.year, this.month, this.day].join('-') + 'T00:00:00';
         this.ngModelCtrl.$setViewValue(val);
      }
   }

   private setInputs(val:string) {
      let date = moment(val, ServerDateFormat);

      if (date.isValid()) {
         this._day = date.date().toString();
         this._month = (date.month() + 1).toString();
         this._year = date.year().toString();
      }

      return val;
   }
}

/**
 * Returns true if the keypress event is a wanted input.
 * Desired input is a control key (e.g. cursor nav, delete/backspace, etc)
 * or number.
 */
function isInputAllowed(event:KeyboardEvent) {
   let code = event.keyCode;

   // del, backspace, tab, esc, shift
   if (code == 46 || code == 8 || code == 9 || code == 27 || code == 16 ||
      (code == 65 && event.ctrlKey === true) || // ctrl+a
      (code >= 35 && code <= 39)) { // end, home, left, up, right
      return true;
   }

   // not a number, or is a number + shift or alt
   if (event.shiftKey === true || event.altKey === true ||
      ((code < 48 || code > 57) && (code < 96 || code > 105 ))) {
      return false;
   }

   return true;
}

ng.module('selfReg').component('dobInput', {
   controller: DobInputController,
   templateUrl: require('./dob-input.html'),
   bindings: {
      isRequired: '<',
      minAge: '<',
      country: '<'
   },
   require: {
      ngFormCtrl: '^form',
      ngModelCtrl: 'ngModel'
   }
});
